import type { ChangeEvent } from 'react';

import { MenuItem, Select, TextField } from '@mui/material';

import type { ExportSettingsType } from '@/features/DataHub/modules/Export/types';

import type { SelectChangeEvent } from '@mui/material/Select';

type RangePeriodFieldsProps = {
  periodNumber: string;
  period: ExportSettingsType['period'];
  periodNumberError: boolean;
  onChangePeriodNumber: (event: ChangeEvent<HTMLInputElement>) => void;
  onChangePeriod: (event: SelectChangeEvent<ExportSettingsType['period']>) => void;
};

export const RangePeriodFields = ({
  periodNumber,
  period,
  periodNumberError,
  onChangePeriodNumber,
  onChangePeriod
}: RangePeriodFieldsProps) => {
  return (
    <>
      <TextField
        error={periodNumberError}
        helperText={periodNumberError ? 'Please enter a valid number' : ''}
        size='small'
        slotProps={{
          htmlInput: {
            maxLength: 2,
            inputMode: 'numeric',
            'aria-label': 'Range period number'
          }
        }}
        sx={{
          ml: 2,
          width: 45,
          '& .MuiInputBase-input': {
            p: '7px 14px'
          },
          '.MuiFormHelperText-root': {
            position: 'absolute',
            ml: 0,
            bottom: '-22px',
            fontSize: '12px',
            width: 150
          }
        }}
        value={periodNumber}
        variant='filled'
        onChange={onChangePeriodNumber}
      />
      <Select
        MenuProps={{
          onClick: e => {
            e.preventDefault();
          },
          sx: { zIndex: 10000 }
        }}
        size='small'
        sx={{
          ml: 2,
          '& .MuiInputBase-input': {
            p: '5.5px 14px',
            backgroundColor: '#272d48'
          },
          '& .MuiMenu-paper': {
            top: '108px!important',
            left: '141px!important'
          }
        }}
        value={period}
        variant='filled'
        onChange={onChangePeriod}
      >
        <MenuItem
          sx={{ fontSize: '14px' }}
          value='d'
        >
          Days
        </MenuItem>
        <MenuItem
          sx={{ fontSize: '14px' }}
          value='m'
        >
          Months
        </MenuItem>
        <MenuItem
          sx={{ fontSize: '14px' }}
          value='y'
        >
          Years
        </MenuItem>
      </Select>
    </>
  );
};
